<div class="cx-product-details-section container" *ngIf="{ product: product() } as content">
  <div class="cx-product-details-section__gallery">
    @if (content.product.isLoading) {
      <div class="loading-container">
        <skeleton-loading class="current-img-loading" />
        <skeleton-loading class="gallery-loading" />
      </div>
    } @else if (content.product && content.product.data) {
      <product-gallery [product]="content.product.data" />
    }
  </div>

  <div class="cx-product-details-section__details">
    @if (content.product.isLoading) {
      <skeleton-loading class="cx-product-details-section__details--header-loading" />
    } @else if (content.product && content.product.data) {
      <div class="cx-product-details-section__details--header">
        <h1>
          {{ content.product.data.name }}
        </h1>
        <p><strong>EAN:</strong> {{ content.product.data.barcode }}</p>
      </div>
    }

    <product-price [price]="price" [stock]="stock" />

    @if (content.product.isLoading) {
      <skeleton-loading class="cx-product-details-section__details--add-to-cart-loading" />
    } @else {
      <div class="cx-product-details-section__details--add-to-cart">
        <cx-input-quantity [min]="0" [formControl]="qtyControl" [label]="'Qtde'" />

        <button
          type="button"
          class="btn btn-primary mt-3 w-100 d-inline-flex align-items-center justify-content-center gap-2"
          (click)="addToCart()"
          [disabled]="qtyControl.value! <= 0 || isAddingToCart()"
        >
          <span *ngIf="isAddingToCart()" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{ 'product.addToCart' | translate }}
        </button>
      </div>
    }
  </div>

  @if (content.product.isLoading) {
    <div class="cx-product-details-section__product-tabs">
      <skeleton-loading class="cx-product-details-section__product-tabs-loading" />
      <skeleton-loading class="cx-product-details-section__product-tabs-loading" />
    </div>
  } @else if (content.product && content.product.data) {
    <div class="cx-product-details-section__product-tabs">
      <product-description [product]="content.product.data" />
      <product-specifications [product]="content.product.data" />
    </div>
  }
</div>
